import type { RecurrenceOverride, Task } from "@app/core";
import { applyOverrides } from "@app/core";

import { splitVirtualId } from "../../lib/virtual-id.js";

export interface NotificationCalendarTarget {
  dueIso: string;
  highlightId: string;
}

/** Resolve an Android notification's stored task id to the calendar position
 * that is visible now. A virtual id carries the immutable RECURRENCE-ID, but a
 * single override may have moved that occurrence to a different due time. */
export function notificationCalendarTarget(
  taskId: string,
  tasks: ReadonlyArray<Task>,
  overrides: Record<string, ReadonlyArray<RecurrenceOverride>>,
): NotificationCalendarTarget | null {
  const { sourceId, occIso } = splitVirtualId(taskId);
  const source = tasks.find((task) => task.id === sourceId && !task.deleted_at);
  if (!source) return null;

  let dueIso: string | null = source.due_at;
  if (occIso) {
    if (!source.recurrence_id) return null;
    dueIso = applyOverrides(source, occIso, overrides[source.recurrence_id] ?? [])?.due_at ?? null;
  }
  if (!dueIso || !Number.isFinite(new Date(dueIso).getTime())) return null;
  return { dueIso, highlightId: occIso ? taskId : sourceId };
}
